import { DynamicInputFormType, InputTypes } from "../../../../../Components";

export const IntraocularPressureConfig: {
  type: string;
  title: string;
  fields: DynamicInputFormType[];
} = {
  type: "Intraocular Pressure",
  title: "Intraocular Pressure",
  fields: [
    {
      dataType: InputTypes.Date,
      accessor: "Date",
      Header: "Date",
    },
    {
      dataType: InputTypes.Number,
      accessor: "OS (mm Hg)",
      Header: "OS (mm Hg)",
    },
    {
      dataType: InputTypes.Number,
      accessor: "OD (mm Hg)",
      Header: "OD (mm Hg)",
    },
  ],
};
